import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M8.82843 3H15.1716C15.702 3 16.2107 3.21071 16.5858 3.58579L20.4142 7.41421C20.7893 7.78929 21 8.29799 21 8.82843V15.1716C21 15.702 20.7893 16.2107 20.4142 16.5858L16.5858 20.4142C16.2107 20.7893 15.702 21 15.1716 21H8.82843C8.29799 21 7.78929 20.7893 7.41421 20.4142L3.58579 16.5858C3.21071 16.2107 3 15.702 3 15.1716V8.82843C3 8.29799 3.21071 7.78929 3.58579 7.41421L7.41421 3.58579C7.78929 3.21071 8.29799 3 8.82843 3ZM11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8ZM12.005 17.3C11.2846 17.3 10.7043 16.72 10.7043 16C10.7043 15.28 11.2846 14.7 12.005 14.7C12.7254 14.7 13.3057 15.28 13.3057 16C13.3057 16.72 12.7254 17.3 12.005 17.3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>,
  'WarningFill',
)
